export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a gestionar la factura"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modificar los datos de la factura"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "add_item_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir item"])},
          "use_issuer_invoice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usar otro emisor de factura"])}
        }
      }
    }
  })
}